import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'businessContactCategories',
  urlRoot: '/business_contact_categories'
})
